import EmailCommunication from '~/pages/communication/email/libs/components/EmailCommunication'

const EmailCommunicationPage = () => <EmailCommunication />

export default EmailCommunicationPage
